import React from 'react'
import {  gql,useQuery} from "@apollo/client"



const USER = gql `
  query Me {
  me {
    name
    apellido
    id
    email
    password
  }
}    `
const User = () => {
  const {data,error,loading} = useQuery(USER)

  return (
    <div className='h-screen flex w-full bg-yellow-500'>
      <div className='bg-gray-200 text-xl font-bold rounded sm:w-4/5 md:w-2/3 lg:w-1/3 m-auto'>
        {data ?   (
          <div className=''>
            <h1 className='text-center mb-4 sm:text-sm underline'>Mi informacion</h1>
            <div className='flex ml-2'>
              <h1>Nombre:</h1>
              <h1 className='ml-4 text-gray-800'>{data.me.name}</h1>
              
            </div>
            <div className='flex ml-2 border-gray-400 mx-2  border-t-2 '>
                <h1>Apellido:</h1>
                <h1 className='ml-4 text-gray-800'>{data.me.apellido}</h1>
            </div>
            <div className='flex border-gray-400 mx-2 border-t-2 mb-4 ml-2'>
                <h1 className=''>Correo:</h1>
                <h1 className='ml-8 text-gray-800 hover:underline text-'>{data.me.email}</h1>
            </div>

            
            
          </div>
        )  :   (
          <div>
            <h1 className='font-medium text-gray-800 '>Cargando...</h1>
          </div>
        )}
          
      </div>
      
    </div>
  )
}

export default User